export default __webpack_public_path__ + "static/graphs-8b0763f8dab11dadb7649065b3208540.webp";